var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.428 4h43.143a3 3 0 013 3v50a3 3 0 01-3 3H10.428a3 3 0 01-3-3V7a3 3 0 013-3z",
    id: "data-table_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.429 0H56.57a4 4 0 014 4v56a4 4 0 01-4 4H7.43a4 4 0 01-4-4V4a4 4 0 014-4z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "data-table_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#data-table_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#data-table_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#data-table_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6174",
    d: "M14.857 26h6.857v-4.571h-6.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD3D4",
    d: "M24 26h6.857v-4.571H24zm9.143 0H40v-4.571h-6.857zm9.143 0h6.857v-4.571h-6.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3CC",
    d: "M14.857 20.286h6.857v-4.572h-6.857zm9.143 0h6.857v-4.572H24zm9.143 0H40v-4.572h-6.857zm9.143 0h6.857v-4.572h-6.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E6174",
    d: "M14.857 31.714h6.857v-4.571h-6.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD3D4",
    d: "M24 31.714h6.857v-4.571H24zm9.143 0H40v-4.571h-6.857zm9.143 0h6.857v-4.571h-6.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E6174",
    d: "M14.857 37.429h6.857v-4.572h-6.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD3D4",
    d: "M24 37.429h6.857v-4.572H24zm9.143 0H40v-4.572h-6.857zm9.143 0h6.857v-4.572h-6.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E6174",
    d: "M14.857 43.143h6.857V38.57h-6.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD3D4",
    d: "M24 43.143h6.857V38.57H24zm9.143 0H40V38.57h-6.857zm9.143 0h6.857V38.57h-6.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E6174",
    d: "M14.857 48.857h6.857v-4.571h-6.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD3D4",
    d: "M24 48.857h6.857v-4.571H24zm9.143 0H40v-4.571h-6.857zm9.143 0h6.857v-4.571h-6.857z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PHBhdGggZD0iTTEwLjQyOCA0aDQzLjE0M2EzIDMgMCAwIDEgMyAzdjUwYTMgMyAwIDAgMS0zIDNIMTAuNDI4YTMgMyAwIDAgMS0zLTNWN2EzIDMgMCAwIDEgMy0zeiIgaWQ9ImEiLz48L2RlZnM+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNNy40MjkgMEg1Ni41N2E0IDQgMCAwIDEgNCA0djU2YTQgNCAwIDAgMS00IDRINy40M2E0IDQgMCAwIDEtNC00VjRhNCA0IDAgMCAxIDQtNHoiIGZpbGw9IiNFQkVCRUIiLz48bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+PHVzZSB4bGluazpocmVmPSIjYSIvPjwvbWFzaz48dXNlIGZpbGw9IiNGRkYiIHhsaW5rOmhyZWY9IiNhIi8+PGcgbWFzaz0idXJsKCNiKSI+PHBhdGggZmlsbD0iIzVFNjE3NCIgZD0iTTE0Ljg1NyAyNmg2Ljg1N3YtNC41NzFoLTYuODU3eiIvPjxwYXRoIGZpbGw9IiNDRkQzRDQiIGQ9Ik0yNCAyNmg2Ljg1N3YtNC41NzFIMjR6bTkuMTQzIDBINDB2LTQuNTcxaC02Ljg1N3ptOS4xNDMgMGg2Ljg1N3YtNC41NzFoLTYuODU3eiIvPjxwYXRoIGZpbGw9IiMzQ0MiIGQ9Ik0xNC44NTcgMjAuMjg2aDYuODU3di00LjU3MmgtNi44NTd6bTkuMTQzIDBoNi44NTd2LTQuNTcySDI0em05LjE0MyAwSDQwdi00LjU3MmgtNi44NTd6bTkuMTQzIDBoNi44NTd2LTQuNTcyaC02Ljg1N3oiLz48cGF0aCBmaWxsPSIjNUU2MTc0IiBkPSJNMTQuODU3IDMxLjcxNGg2Ljg1N3YtNC41NzFoLTYuODU3eiIvPjxwYXRoIGZpbGw9IiNDRkQzRDQiIGQ9Ik0yNCAzMS43MTRoNi44NTd2LTQuNTcxSDI0em05LjE0MyAwSDQwdi00LjU3MWgtNi44NTd6bTkuMTQzIDBoNi44NTd2LTQuNTcxaC02Ljg1N3oiLz48cGF0aCBmaWxsPSIjNUU2MTc0IiBkPSJNMTQuODU3IDM3LjQyOWg2Ljg1N3YtNC41NzJoLTYuODU3eiIvPjxwYXRoIGZpbGw9IiNDRkQzRDQiIGQ9Ik0yNCAzNy40MjloNi44NTd2LTQuNTcySDI0em05LjE0MyAwSDQwdi00LjU3MmgtNi44NTd6bTkuMTQzIDBoNi44NTd2LTQuNTcyaC02Ljg1N3oiLz48cGF0aCBmaWxsPSIjNUU2MTc0IiBkPSJNMTQuODU3IDQzLjE0M2g2Ljg1N1YzOC41N2gtNi44NTd6Ii8+PHBhdGggZmlsbD0iI0NGRDNENCIgZD0iTTI0IDQzLjE0M2g2Ljg1N1YzOC41N0gyNHptOS4xNDMgMEg0MFYzOC41N2gtNi44NTd6bTkuMTQzIDBoNi44NTdWMzguNTdoLTYuODU3eiIvPjxwYXRoIGZpbGw9IiM1RTYxNzQiIGQ9Ik0xNC44NTcgNDguODU3aDYuODU3di00LjU3MWgtNi44NTd6Ii8+PHBhdGggZmlsbD0iI0NGRDNENCIgZD0iTTI0IDQ4Ljg1N2g2Ljg1N3YtNC41NzFIMjR6bTkuMTQzIDBINDB2LTQuNTcxaC02Ljg1N3ptOS4xNDMgMGg2Ljg1N3YtNC41NzFoLTYuODU3eiIvPjwvZz48L2c+PC9zdmc+";
export { SvgDataTable as ReactComponent };